import { ActionsAndSubjectsResponse } from "@/types/WorkflowCreate/AppConfiguration";
import { SelectOption } from "@/types/inputField";

export const getAllSubjectsByAppAndAction = (
  actionsAndSubjects: ActionsAndSubjectsResponse[] | undefined,
  actionName: string
): SelectOption[] => {
  if (!actionsAndSubjects || !actionName) return []

  const availableAction = actionsAndSubjects.find(actionAndSubject => actionAndSubject.actionCode === actionName)
  if (!availableAction) return []

  return availableAction.availableSubjects.map(subject => ({
    id: subject.code,
    value: subject.displayName,
    description: subject.description
  }))
}
